const initialState = {
  modalDetailUsaha: true,
  getAllListUsaha: [],
};

const listUsahaReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_DETAIL_USAHA":
      return {
        ...state,
        modalDetailUsaha: data,
      };
    case "SET_GET_LIST_USAHA":
      return {
        ...state,
        getAllListUsaha: data,
      };
    default:
      return state;
  }
};

export default listUsahaReducer;
